import React from 'react';
import { ResponsiveGrid } from '@alifd/next';
import PageHeader from '@/components/PageHeader';
import BroadcastList from './components/BroadcastList';

const { Cell } = ResponsiveGrid;

const Accounting = () => (
  <ResponsiveGrid gap={20}>
    <Cell colSpan={12}>
      <PageHeader
        title="公播列表"
        breadcrumbs={[
          {
            name: '公播管理',
          },
          {
            name: '公播列表',
          },
        ]}
      />
    </Cell>

    <Cell colSpan={12}>
      <BroadcastList />
    </Cell>
  </ResponsiveGrid>
);

export default Accounting;
